import * as React from 'react';
import { SVGProps } from 'react';

const IconDebugSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9.158 8.455a4 4 0 0 0-2.66-6.424V1.024a5 5 0 0 1 3.372 8.142l-.712-.711ZM5.5 1.025a5 5 0 0 0-3.372 8.138l.711-.711a4 4 0 0 1 2.66-6.42V1.024ZM6 10a3.983 3.983 0 0 1-2.454-.841l-.711.712A4.98 4.98 0 0 0 6 11c1.2 0 2.3-.423 3.162-1.127l-.711-.712A3.983 3.983 0 0 1 6 10ZM5 8l3-2-3-2v4Z" />
  </svg>
);
export default IconDebugSizeXs;
